import React from 'react';
import { formatDateStr } from '@gp/utils/common';
import { CARD_TITLE } from '../../../components/Calendar/utils';
import ReviewCalendar, { IReviewCalendarProps } from '../../../components/Calendar/ReviewCalendar';

import type { IBaseProps } from '@home/types/common';

interface IReviewCalendarV2Props extends IBaseProps, IReviewCalendarProps {}

const getCalendarQuater = (date?: string): string => {
  if (!date) return CARD_TITLE;
  const quaterStr = formatDateStr(date, 'Q');
  return quaterStr ? `${CARD_TITLE} Q${quaterStr}` : CARD_TITLE;
};

const ReviewCalendarV2: React.FC<IReviewCalendarV2Props> = (props) => {
  const { date, ...restProps } = props;

  return <ReviewCalendar {...restProps} title={getCalendarQuater(date)} />;
};

export default ReviewCalendarV2;
